/**
 * Price list
 *
 * @module price-list
 */
const component = {

    /**
     * Init module
     * 
     * @returns {boolean|undefined}
     */
    init: () => {

		component.target = document.querySelector("price-list");
        component.overlay = document.querySelector("[data-price-list-overlay]");

		if(!component.target) return false;

        component._initCloseEvents();
        component._open();
       //component._tooltip();
	},

    /**
	 * start to listen the tooltip hover
     * @returns {undefined}
	 */
    _tooltip: () => {
        let tooltip = document.querySelector("[data-price-list-tooltip]");
        let priceOpen = document.querySelector("[data-price-list-open]");

        if ((window.screenMode == 'desktop-large' || window.screenMode == 'desktop') && tooltip && priceOpen) {

            priceOpen.addEventListener('mousemove', (e) => {
                tooltip.classList.add('active');
                tooltip.style.left = (e.clientX - 25) + 'px';
                tooltip.style.top = (e.clientY + 30) + 'px';	
            });

            priceOpen.addEventListener('mouseleave', () => {
                tooltip.classList.remove('active');
            });
        }
    },

    /**
	 * start to listen the click button to close Price list
     * @returns {undefined}
	 */
    _initCloseEvents: () => {
        document.querySelectorAll('[data-price-list-close]').forEach(item => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                component._close();
            });
        });
    },

    /**
     * Close Price list
     * 
     * @returns {undefined}
     */    
    _close: () => {
        
		component.disableFocusTrap();
        document.body.style.overflow = 'auto';
        component.overlay.classList.remove("active");

        setTimeout(() => {
            component.target.classList.remove("active");
			component.target.setAttribute('aria-hidden', 'true');
        }, 50);
    },

    /**
     * Open Price list
     * 
     * @returns {undefined}
     */
    _open: () => {
        document.querySelector("[data-price-list-open]").addEventListener('click', (event) => {
            event.preventDefault();

            document.body.style.overflow = 'hidden';
            component.target.classList.add("active");
            component.target.setAttribute('aria-hidden', 'false');

            setTimeout(() => {
                component.overlay.classList.add("active");
                component.activeFocusTrap();
            }, 50);
        });
    },

    /**
     * Init Price list focus trap
     * 
     * @returns {undefined}
     */
    initFocusTrap: () => {
        component.focusTrap = focusTrap.createFocusTrap(component.target, { clickOutsideDeactivates: true });
    },

    /**
     * Ative Price list focus trap
     * 
     * @returns {undefined}
     */
    activeFocusTrap: () => {
        if (component.focusTrap) {
            component.focusTrap.activate();
        }
    },

    /**
     * Disable Price list focus trap
     * 
     * @returns {undefined}
     */
    disableFocusTrap: () => {
        if (component.focusTrap) {
            component.focusTrap.deactivate();
        }
    }

}

export default component;